import { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("ramalho_token"));
  const [username, setUsername] = useState(() => localStorage.getItem("ramalho_user"));

  const login = useCallback(async (u, p) => {
    const { data } = await api.post("/auth/login", { username: u, password: p });
    localStorage.setItem("ramalho_token", data.token);
    localStorage.setItem("ramalho_user", data.username);
    setToken(data.token);
    setUsername(data.username);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("ramalho_token");
    localStorage.removeItem("ramalho_user");
    setToken(null);
    setUsername(null);
  }, []);

  return (
    <AuthContext.Provider value={{ token, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
